export const isEmpty = (value: string | number | undefined) => {
  if (typeof value === 'string') {
    return value === '';
  }

  return value === undefined || value === null;
};

export const hasWhitespace = (value: string) => {
  return /\s/g.test(value);
};

export const isAlphaNumeric = (value: string) => {
  return /^(?=.*[a-zA-Z])(?=.*[0-9])/.test(value);
};

export const isValidEmail = (value: string) => {
  return /^\S+@\S+$/.test(value);
};

export const isValidHexColor = (hexCode?: string) => {
  if (!hexCode || hexCode === '') {
    return false;
  }

  return /^#?([0-9A-F]{3}){1,2}$/i.test(hexCode);
};
export const isValidUrl = (value: string) => {
  if (!value.startsWith('http://') && !value.startsWith('https://')) {
    return false;
  }

  const domain = 'example.com';
  // Replace all {{domain}} in the URL with the sample domain
  const valueWithSampleDomain = value.replace(/\{\{domain\}\}/g, domain);
  // Replace {{}} template placeholders with a valid placeholder for validation, it will fail if user provide {language} <-- single {}
  const urlForValidation = valueWithSampleDomain.replace(/\{\{[^}]+\}\}/g, 'placeholder');

  const pattern = new RegExp(
    '^(https?:\\/\\/)' + // protocol (required)
      '(?:([^:@\\s{}]+):([^@\\s{}]+)@)?' + // optional user:password@ (excludes single {})
      '(?:' +
      '([a-z\\d]([a-z\\d-]*[a-z\\d])*\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3})|' + // IPv4 address
      '\\[([a-f\\d:]+)\\]' + // IPv6 address in brackets
      ')' +
      '(?::(\\d+))?' + // optional port
      '(?:\\/([^?#\\s{}]*))?' + // optional path (excludes single {})
      '(?:\\?([^#\\s{}]*))?' + // optional query string (excludes single {})
      '(?:#([^\\s{}]*))?$', // optional fragment (excludes single {})
    'i'
  );

  return pattern.test(urlForValidation);
};
